<main class="main" [style]="{ 'background-color': pageConfiguration()?.backgroundColor }">
  <mat-progress-bar
    *ngIf="isLoading$ | async"
    class="app-progress-bar position-fixed"
    mode="indeterminate"
  ></mat-progress-bar>

  @if (!isIframe) {
    <app-toolbar></app-toolbar>
  }

  @if (!isHeaderHidden) {
    <app-page-header></app-page-header>
  }
  <router-outlet />
</main>
